import React from "react";

import {graphql} from "gatsby";

import Section from "../../components/Section";
import Layout from "../../components/Layout";
import Menus from "../../components/Menus";
import PrivateRoute from "../../components/PrivateRoute";

function MenusPageContent(props) {
	return (
		<>
			<Layout location={props.location}>
				<Section title={" "}>
					<Menus />
				</Section>
			</Layout>
		</>
	);
}

export default function MenusPage(props) {
	return <PrivateRoute component={MenusPageContent} location={props.location} />;
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
